const enum StreamType {
    LIVE = "live",
    VOD = "vod"
}

export default StreamType;
